function showConditionInfo(){
    $('#overlay, .popupWrapper, #popup-condition-guide').fadeIn();
    return false;
}
